<div class="checkbox-container">
  <div class="input-container" [class.error]="errorMessage()" [formGroup]="form">
    <input
      type="checkbox"
      [id]="name()"
      [formControlName]="controlName()"
      (keydown.enter)="checkbox.click()"
      [attr.aria-label]="altText()"
      [attr.aria-required]="required()"
      #checkbox
    />
    <label [for]="name()" [class.visually-hidden]="!isContentVisible()">
      <ng-content></ng-content>
    </label>
  </div>
  @if (isContentVisible() && errorMessage(); as _message) {
    <span class="error-message">{{ _message }}</span>
  }
</div>
